import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  Link,
  useOutletContext,
  useParams,
} from "react-router-dom";
import toastr from "../../utils/toast";
import AddProspect from "../lead_dashboard/components/AddProspect";
import ExecutivesModal from "./ExecutivesModal";
import useSmartBack from "../../hooks/useSmartBack";
import { openInAppTab } from "../../utils/tabNavigation";

function View() {
  const { id } = useParams();
  const handleBack = useSmartBack("/lead_dashboard/pipeline");
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [companyInfo, setCompanyInfo] = useState([]);
  const [OrganisationContacts, setOrganisationContacts] = useState([]);
  const [Timeline, setTimeline] = useState([]);
  const [Scheduled, setScheduled] = useState([]);
  const [ProspectCandidates, setProspectCandidates] = useState([]);
  const [showAddProspect, setShowAddProspect] = useState(false);
  const [companyinfo_id, setCompanyinfo_id] = useState(null);
  const [showexecutivesModal, setShowexecutivesModal] = useState(false);

  const companyInfoDetails = useRef(false);

  async function get_companyinfo_details() {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/companyinfo/get_detailed_companyinfo/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log(response.data);
      setCompanyInfo(response.data.companyinfo?.[0]);
      setOrganisationContacts(response.data.organisation_contacts);
      setTimeline(response.data.timeline);
      setScheduled(response.data.scheduled);
      setProspectCandidates(response.data.prospect_candidates);
    } catch (error) {
      setGlobalLoading(false);
      toastr.error(error.response.data.message);
    } finally {
      setGlobalLoading(false);
    }
  }

  useEffect(() => {
    if (companyInfoDetails.current) {
      return;
    }
    companyInfoDetails.current = true;
    get_companyinfo_details();
  }, [id]);

  const get_user_shortname = (name) => {
    if (name) {
      const names = name.split(" ");
      if (names.length > 1) {
        return names[0][0] + names[1][0];
      } else {
        return names[0][0];
      }
    }
  };

  return (
    <>
      {showAddProspect && companyinfo_id && (
        <AddProspect
          onClose={() => setShowAddProspect(false)}
          companyinfo_id={companyinfo_id}
        />
      )}

      {showexecutivesModal && (
        <ExecutivesModal
          onClose={() => {
            get_companyinfo_details();
            setShowexecutivesModal(false);
          }}
          id={companyInfo?.id}
          seniority_level={9}
        />
      )}
      <div className="container py-4">
        {/* <!-- Header --> */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <a
              onClick={handleBack}
              className="text-muted small d-block mb-2 ms-2"
            >
              <i className="fa-solid fa-arrow-left"></i> Back to Pipeline
            </a>

            <h3 className="fw-bold mb-2 ms-2">{companyInfo?.name}</h3>

            <div className="d-flex flex-wrap gap-2 align-items-center">
              <span className="badge rounded-pill bg-secondary">
                {companyInfo?.industrymaster}
              </span>
              <span className="badge rounded-pill bg-outline-light text-dark">
                {companyInfo?.industry}
              </span>
              <span className="text-muted small">
                📍 {companyInfo?.country_name}
              </span>
              <span
                className={`badge rounded-pill ${companyInfo?.status_color}`}
              >
                {companyInfo?.pipeline_status}
              </span>
              <span className="text-muted small">
                Assigned To:{" "}
                <span className="text-dark">{companyInfo?.assign_to}</span>
              </span>
            </div>
          </div>

          <div>
            <button
              onClick={() => window.open(companyInfo?.website)}
              className="btn btn-outline-secondary btn-sm"
            >
              {companyInfo?.website}
            </button>
          </div>
        </div>

        {/* <!-- Alert --> */}
        {ProspectCandidates?.length > 0 && (
          <div className="card border-warning mb-4">
            <div className="card-body">
              <div className="mb-3">
                <i className="fa-solid fa-triangle-exclamation text-warning"></i>{" "}
                <span className="fw-semibold text-dark fs-14">
                  Contact Job Change Alert
                </span>
              </div>
              {ProspectCandidates?.map((item, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center border rounded p-3 mb-1"
                >
                  <div>
                    <div className="fw-semibold text-dark">
                      {item?.firstname + " " + item?.lastname}{" "}
                      <span className="text-muted">({item?.designation})</span>
                    </div>
                    <div className="text-muted small">
                      Has moved to{" "}
                      <span className="fw-semibold text-dark">
                        {item?.current_company_name}
                      </span>
                    </div>
                    <div className="text-muted small">
                      → Consider adding {item?.current_company_name} as a new
                      prospect
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      setCompanyinfo_id(item?.current_companyinfo_id);
                      setShowAddProspect(true);
                    }}
                    className="btn btn-outline-warning btn-lg"
                  >
                    <i className="fa-solid fa-building me-1"></i>
                    Add as Prospect
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="row">
          {/* <!-- LEFT: Contacts --> */}

          <div className="col-md-7">
            <div className="card">
              <div className="card-header">
                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                  <h5>Organization Contacts</h5>
                  <div>
                    <button
                      onClick={() => setShowexecutivesModal(true)}
                      className="btn btn-outline-secondary btn-sm"
                    >
                      <i className="fa-solid fa-magnifying-glass me-1"></i> Show
                      Executives
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body lead_dashboard_reminder">
                {OrganisationContacts.length > 0 ? (
                  <>
                    {OrganisationContacts?.map((contact) => (
                      <>
                        {/* <!-- Contact Card --> */}
                        <div className="border rounded p-3 mb-3 bg-light">
                          <div className="d-flex">
                            <div className="me-3">
                              <div
                                className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center"
                                style={{ width: "40px", height: "40px" }}
                              >
                                {get_user_shortname(contact?.contact_name)}
                              </div>
                            </div>

                            <div>
                              <div className="fw-semibold">
                                <Link
                                  target="_blank"
                                  to={`/candidates/view/${contact?.contact_id}`}
                                  className="text-info me-1"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    openInAppTab(
                                      `/candidates/view/${contact?.contact_id}`,
                                    );
                                  }}
                                >
                                  {contact?.contact_name}
                                </Link>
                                <span className="text-success">✔</span>
                              </div>
                              <div className="text-muted small">
                                {contact?.designation}
                              </div>
                              {contact?.country_name && (
                                <div className="text-muted small">
                                  📍 {contact?.country_name}
                                </div>
                              )}
                              {(contact?.email || contact?.mobile) && (
                                <div className="text-muted small mt-1">
                                  {contact?.email && (
                                    <span
                                      onClick={() =>
                                        window.open(`mailto:${contact?.email}`)
                                      }
                                      style={{ cursor: "pointer" }}
                                      className="me-2 me-sm-1 text-primary"
                                    >
                                      <i className="fa-solid fa-envelope"></i>{" "}
                                      {contact?.email}
                                    </span>
                                  )}
                                  {contact?.phone && (
                                    <span className="me-2">
                                      <i className="fa-solid fa-phone"></i>{" "}
                                      {contact?.phone}
                                    </span>
                                  )}
                                  {contact?.mobile && (
                                    <span className="me-2">
                                      <i className="fa-solid fa-phone"></i>{" "}
                                      {contact?.mobile}
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </>
                ) : (
                  <div className="text-muted small">No Contacts Added</div>
                )}
              </div>
            </div>
          </div>

          {/* <!-- RIGHT: Timeline --> */}
          {Timeline?.length > 0 && (
            <div className="col-md-5">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Engagement Timeline</h5>
                  </div>
                </div>
                <div className="card-body lead_dashboard_reminder">
                  <div className="schedule-timeline activity-timeline">
                    {Timeline?.map((timeline, index) => (
                      <div key={index} className="d-flex align-items-start">
                        <div className="avatar avatar-md avatar-rounded bg-purple flex-shrink-0"></div>
                        <div className="flex-fill ps-3 timeline-flow d-flex meeting-list mb-2">
                          <p className="fw-medium text-gray-9 mb-1">
                            {timeline?.notes || (
                              <span className="text-danger">
                                No Notes Added
                              </span>
                            )}
                          </p>
                          <span className="fw-400 text-dark">
                            {new Date(
                              timeline?.meeting_date,
                            ).toLocaleDateString("en-CA")}
                            <span className="ms-1">
                              |{"  "}
                              {timeline?.status}
                            </span>
                          </span>
                          <span className="fw-400 text-dark">{`${timeline?.user} : ${timeline?.contact_name}`}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <hr className="mt-0 p-0 opacity-100" />
                {Scheduled?.length > 0 && (
                  <div className="container">
                    <div className="col-md-12">
                      <div className="row d-flex align-items-center">
                        {Scheduled?.map((item, index) => (
                          <div
                            key={index}
                            className="mb-2 col-md-4 col-xl-4 col-xxl-4 text-center"
                          >
                            <div className="text-dark fw-semibold">
                              {item?.type === "next_meeting"
                                ? "NEXT MEETING"
                                : item?.type === "last_meeting"
                                  ? "LAST MEETING"
                                  : "UPCOMING"}
                            </div>
                            <div>
                              {new Date(item?.meeting_date).toLocaleDateString(
                                "en-CA",
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default View;
